<template>
    <div class="screenPaper tg-area-select" id="screenPaper">
        <div class="screen">
            <div class="title text-center fs-18">
                <i class="icon icon-back float-left fs-22" style="width: 44px;line-height: 44px" @click="closeSelecter"></i>
                <span>选择地区</span>
            </div>
            <div style="overflow-y: scroll;height: calc(100% - 44px)">
                <ul id="provinceList" v-if="!provinceObj.id">
                    <li v-for="item in provinceList" v-text="item.name" @click="_provinceHandler(item)"></li>
                </ul>
                <ul id="cityList" v-if="!cityObj.id">
                    <li v-for="item in cityList" v-text="item.name" @click="_cityHandler(item)"></li>
                </ul>
                <ul id="areaList">
                    <li v-for="item in areaList" v-text="item.name" @click="_areaHandler(item)"></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
div.screenPaper {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
}
div.screenPaper .screen {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    width: 87.5%;
    background: #fff;
}
div.screenPaper .screen .title {
    line-height: 44px;
}
div.screenPaper .screen li{
    padding-left: 20px;
    height: 40px;
    border-bottom:1px #ebebeb solid;
    line-height:40px;
    font-size:14px;
    font-weight:400;
    color:#222;
}
div.screenPaper .screen li.province{
    color:#16bb80;
    background:url("//image1.51tiangou.com/tgou2/img2/mine/ico_right.png") no-repeat 12.25rem center;
    background-size:1rem auto;
}
div.screenPaper .screen li.seled_pro{
    background:#f8f8f8;
}
</style>
<script>
import {api} from "tgPage";

export default {
    name: "tg-area-select",
    props: {
    },
    data() {
        return {
            provinceList: [],
            cityList: [],
            areaList: [],
            provinceObj: {},
            cityObj: {},
            areaObj: {}
        }
    },
    created() {
        this._loadAreaData()
    },
    methods: {
        _loadAreaData() {
            api.base.provinceList({
                data: {},
                success: (data) => {
                    this.provinceList = data;
                }
            })
        },
        _provinceHandler(item) {
            this.provinceObj = {id:item.id,name:item.name};
            //加载城市
            this._loadCity();
        },
        _loadCity() {
            api.base.cityListByProvince({
                data: {provinceId:this.provinceObj.id},
                success: (data) => {
                    this.cityList = data;
                }
            })
        },
        _cityHandler(item) {
            this.cityObj = {id:item.id,name:item.name};
            // 加载区
            this._loadArea();
        },
        _loadArea() {
            api.base.districtList({
                data: {cityId:this.cityObj.id},
                success: (data) => {
                    this.areaList = data;
                }
            })
        },
        _areaHandler(item) {
            this.areaObj = {id:item.id,name:item.name};
            this.$dispatch('areaEvent', [this.provinceObj, this.cityObj, this.areaObj]);
        },
        closeSelecter() {
            this.$dispatch('areaEvent');
        }
    }
}
</script>